export default {
  folders: (state) => state.folders,
  folderView: (state) => state.folderView,
  postsByFolder: (state) => state.postsByFolder,
  morePost: (state) => state.morePost,
  isDeletePost: (state) => state.isDeletePost,
  isLoading: (state) => state.isLoading
};
